import o from "../../../node_modules/prop-types/index.es.js";
import d from "styled-components";
const i = d.div.withConfig({
  displayName: "HorizontalDivider",
  componentId: "sc-7hvhro-0"
})(["border-top-color:", ";border-top-style:", ";border-top-width:1px;height:1px;margin:", ";width:", ";"], ({
  $color: r,
  $variant: e = "default"
}) => r || e === "dark" ? "var(--color-border-strong)" : "var(--color-border-default)", ({
  $dashed: r
}) => r ? "dashed" : "solid", ({
  $margin: r = 0
}) => r, ({
  $width: r = "100%"
}) => typeof r == "number" ? `${r}px` : r), t = d.div.withConfig({
  displayName: "VerticalDivider",
  componentId: "sc-7hvhro-1"
})(["border-left-color:", ";border-left-style:", ";border-left-width:1px;height:", ";margin:", ";width:1px;"], ({
  $color: r,
  $variant: e = "default"
}) => r || e === "dark" ? "var(--color-border-strong)" : "var(--color-border-default)", ({
  $dashed: r
}) => r ? "dashed" : "solid", ({
  $height: r = "100%"
}) => typeof r == "number" ? `${r}px` : r, ({
  $margin: r = 0
}) => r), a = {
  color: o.string,
  dashed: o.bool,
  margin: o.string,
  height: o.oneOfType([o.string, o.number]),
  variant: o.oneOf(["default", "dark"]),
  width: o.oneOfType([o.string, o.number])
};
i.displayName = "HorizontalDivider";
i.propTypes = a;
t.displayName = "VerticalDivider";
t.propTypes = a;
export {
  i as HorizontalDivider,
  t as VerticalDivider,
  a as dividerPropTypes
};
//# sourceMappingURL=Dividers.es.js.map
